import { useTranslation } from "react-i18next";
import { ao3ScrollToSection } from "@/hooks/ao3ScrollToSection";
import { ao3Assets } from "@/mocks/ao3Home";
import Ao3Reveal from "./Ao3Reveal";

export default function Ao3Cta() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-background-100 border-y border-background-200/70 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <Ao3Reveal>
          <div className="relative overflow-hidden rounded-lg border border-background-200/70">
            <img
              src={ao3Assets.ctaBackground}
              alt="Warm paper texture with crimson brush marks"
              title="AO3 Reader — read the archive anywhere"
              className="absolute inset-0 h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-primary-950/80 dark:bg-primary-100/85" />
            <div className="relative flex flex-col items-center gap-5 px-6 py-12 text-center md:px-12 md:py-16">
              <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-xs font-semibold tracking-[0.16em] text-accent-200 dark:border-foreground-950/30 dark:bg-foreground-950/10 dark:text-accent-700">
                <i className="ri-book-open-line text-sm leading-none" />
                {t("cta.badge")}
              </span>
              <h2 className="max-w-2xl font-heading text-2xl font-semibold text-background-50 dark:text-foreground-950 md:text-4xl">{t("cta.title")}</h2>
              <p className="max-w-2xl text-sm leading-relaxed text-background-50/80 dark:text-foreground-950/85 md:text-base">{t("cta.desc")}</p>
              <button
                type="button"
                onClick={() => ao3ScrollToSection("ao3-top")}
                className="mt-1 inline-flex items-center gap-2 cursor-pointer rounded-md border border-background-50/40 bg-background-50/10 px-6 py-3 text-sm font-semibold whitespace-nowrap text-background-50 transition-colors hover:bg-background-50/20 dark:border-foreground-950/40 dark:bg-foreground-950/10 dark:text-foreground-950 dark:hover:bg-foreground-950/20 md:text-base"
              >
                <i className="ri-compass-3-line text-lg leading-none" />
                {t("cta.entry")}
                <span className="text-xs font-normal text-background-50/70 dark:text-foreground-950/70">· {t("cta.entryNote")}</span>
              </button>
            </div>
          </div>
        </Ao3Reveal>
      </div>
    </section>
  );
}